import React, { useEffect } from "react";
import moment from "moment";
import DataTable from "./DataTable";
import { useDispatch, useSelector } from "react-redux";
import { getAllTransactions } from "../features/admin/adminSlice";

function Payments() {
  const dispatch = useDispatch();

  const { payments = [], transactions = [] } = useSelector(
    (state) => state.admin,
  );

  useEffect(() => {
    dispatch(getAllTransactions());
  }, [dispatch]);

  const paymentColumns = [
    { label: "Organization", key: "organizationName" },
    { label: "Owner", key: "ownerName" },
    { label: "Email", key: "ownerEmail" },
    { label: "Amount", key: "amount" },
    { label: "Status", key: "status" },
    { label: "Invoice", key: "invoiceId" },
    { label: "Created", key: "createdAt" },
  ];

  const transactionColumns = [
    { label: "Organization", key: "organizationName" },
    { label: "Owner", key: "ownerName" },
    { label: "Email", key: "ownerEmail" },
    { label: "Type", key: "type" },
    { label: "Credits", key: "credits" },
    { label: "Description", key: "description" },
    { label: "Status", key: "status" },
    { label: "Created", key: "createdAt" },
  ];

  const paymentRows = (p) => (
    <tr key={p.uuid}>
      <td className="ps-3">{p.organizationName}</td>
      <td className="ps-3">{p.ownerName}</td>
      <td className="ps-3">{p.ownerEmail}</td>
      <td className="ps-3">${p.amount}</td>
      <td className="ps-3 text-capitalize">{p.status}</td>
      <td className="ps-3">{p.invoiceId || p.paymentIntentId || "-"}</td>
      <td className="ps-3">{moment(p.createdAt).format("MMM D, YYYY")}</td>
    </tr>
  );

  const transactionRows = (t) => (
    <tr key={t.uuid}>
      <td className="ps-3">{t.organizationName}</td>
      <td className="ps-3">{t.ownerName}</td>
      <td className="ps-3">{t.ownerEmail}</td>
      <td className="ps-3 text-capitalize">{t.type}</td>
      <td className="ps-3">{t.credits}</td>
      <td className="ps-3">{t.description}</td>
      <td className="ps-3 text-capitalize">{t.status}</td>
      <td className="ps-3">{moment(t.createdAt).format("MMM D, YYYY")}</td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12 mb-4">
          <DataTable
            title="Payments"
            data={payments}
            columns={paymentColumns}
            rowRenderer={paymentRows}
          />
        </div>

        <div className="col-12">
          <DataTable
            title="Credit Transactions"
            data={transactions}
            columns={transactionColumns}
            rowRenderer={transactionRows}
          />
        </div>
      </div>
    </div>
  );
}

export default Payments;
